module.exports = __webpack_public_path__ + "static/media/Sampon_na_vlasy_s_CBD_retina.c9448d2d.png";